module.exports = __webpack_public_path__ + "static/media/garantia.174c9aa5.png";